import Link from '#src/components/Link';
import { CloudinaryImage } from '#src/components/CloudinaryImage';
import { flattenImageAsset } from '#src/lib/contentful/selectors.mjs';

import { LoginStatus } from './LoginStatus.js';
import styles from './Header.scss';

export function Header({ logo }) {
  return (
    <header className={styles.container}>
      <nav className={styles.nav}>
        <Link to="/" className={styles.logoContainer}>
          <CloudinaryImage
            {...flattenImageAsset(logo)}
            className={styles.logo}
          />
        </Link>
        <LoginStatus className={styles.login} />
      </nav>
    </header>
  );
}
